<template>
<div class="loading-spinner1">
    <b-modal style="padding: 0px;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
        <div class="text-center" style="color: #FFF">
            <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
        </div>
    </b-modal>
</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { PACKAGE } from '../../../package_constants'
export default {
  name: 'userTrack',
  props: ['role'],
  components: {
  },
  data: () => {
    return {
      isNuNavLogin: (window.location.host.indexOf('nunav') !== -1 || window.location.host.indexOf('competencyedu') !== -1 || window.location.host.indexOf('wsp') !== -1)
    }
  },

  mounted () {
    this.$refs.loadingModal.show()
    this.loadUserTrack()
  },

  methods: {
    ...mapActions([
      'loadLogDashboardActivity',
      'loadInstitutionDetail'
    ]),

    async loadUserTrack () {
      // log login activity
      this.loadLogDashboardActivity({action: 'login', page: 'login', link: ''})
      // redirect to dashboard
      let url = '/dashboard/' + this.role.split('_').join('/')
      if (!this.isNuNavLogin) {
          const institutionId = this.institution.uuid || localStorage.getItem('institutionId')
          if((this.role === 'student' || this.role === 'Student')) {
            await this.loadInstitutionDetail(institutionId).then(res => { 
                 if(res.learnerDashboard && (res.learnerDashboard.indexOf('modern')!=-1)){
                        url = '/dashboard/modern'
                 }
              });
          }

           let learnerDBFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.SHOW_LEARNER_DASHBOARD_FEATURE_ID]
           if(learnerDBFeature && learnerDBFeature.enabled && (this.role === 'student' || this.role === 'Student')) {
                if(this.institution.learnerDashboard && this.institution.learnerDashboard.length>7){
                  url = this.institution.learnerDashboard 
                }else{
                  url = '/dashboard/learner'
                }
           }
      } else { // Nunav login
        if (this.role === 'admin') {
          url = '/dashboard/nunav/admin'
        }
      }
      return this.$router.push(url)
    }
  },

  computed: {
      ...mapState({
      'institution': state => state.institution.institution,
      'enabledFeatures': state => state.institution.enabledFeatures
    })
  },

  watch: {
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/app/user/components/UserTrack.vue